"use client";
import CourseRating from "@/components/CourseContent/CourseRating";
import { Badge } from "@/components/ui/badge";
import useTranslations from "@/i18n/useTranslations";

type SideRailRatingProps = {
  count?: number;
  average?: number;
  enrollmentCount: number;
  showTrendingBadge?: boolean;
};

export default function SideRailRating({
  count,
  average,
  enrollmentCount,
  showTrendingBadge = false,
}: SideRailRatingProps) {
  const t = useTranslations("Course");
  const tCommon = useTranslations("Common");
  return (
    <div className="flex flex-col gap-2">
      {count && average && (
        <div className="flex justify-between items-center">
          <CourseRating
            count={count}
            average={average}
            variant="solid"
            ratingClassName="text-gray-800"
          />
          {showTrendingBadge && (
            <Badge
              variant="primaryLight"
              className="font-normal whitespace-nowrap bg-secondary-500 border-putty-400 !rounded !shadow-none px-2"
            >
              {tCommon("trending")}
            </Badge>
          )}
        </div>
      )}
      {enrollmentCount && (
        <div className="flex items-center">
          <span className="font-bold text-gray-800 m-0">
            {enrollmentCount.toLocaleString()}
          </span>
          <span className="m-0 text-gray-800">
            &nbsp;{t("learnersEnrolled")}
          </span>
        </div>
      )}
    </div>
  );
}
